// extracted by mini-css-extract-plugin
export var card = "_lf-0";
export var content = "_lf-2";
export var details = "_lf-3";
export var icon = "_lf-1";
export var iconBlue = "_lf-5";
export var iconBrand = "_lf-4";
export var iconGrayBlue = "_lf-6";
export var iconGreen = "_lf-7";
export var iconIndigo = "_lf-8";
export var iconOrange = "_lf-9";
export var iconPurple = "_lf-a";
export var iconRed = "_lf-b";
export var iconWarning = "_lf-c";